import { Operation } from '../../../__generated__/globalTypes'

import acceptSharedContactString from '../AcceptSharedContact.graphql'

export type AcceptSharedContactData = {
  acceptContactShare: {
    accepted: boolean
  }
}

export type AcceptSharedContactVariables = {
  id: string
}

export type AcceptSharedContact = Operation<
  AcceptSharedContactData,
  AcceptSharedContactVariables
>

export const AcceptSharedContact = ({
  id,
}: AcceptSharedContactVariables): AcceptSharedContact => ({
  query: acceptSharedContactString,
  variables: {
    id,
  },
})
